import {delay} from 'redux-saga';
import {put, fork, cancel, call, take, select} from 'redux-saga/effects';
import jwt_decode from 'jwt-decode';
import ApiActions from 'go/actions/api';
import {API_AUTH_LOGIN_SUCCESS, LOGOUT, API_AUTH_REFRESH_SUCCESS} from 'common/types';

export default function* loginSaga() {
  yield call(waitForLogin);
}

export function* waitForLogin() {
  yield take(API_AUTH_LOGIN_SUCCESS);
  yield call(setUpUserAfterLogin);
  const task = yield fork(loginFlow);
  yield take(LOGOUT);
  yield cancel(task);
  yield call(waitForLogin);
}

export function* setUpUserAfterLogin() {
  const state = yield select();
  const token = getTokenFromState(state);
  const userId = token.userId;
  const jwt = state && state.auth ? state.auth.token : '';
  yield put(ApiActions.profile.getUser(userId, jwt));
  yield put(ApiActions.userEntities.getUserEntities(jwt));
}

export function* loginFlow() {
  const state = yield select();
  const token = getTokenFromState(state);
  let time = calculateTimeToDelay(token);
  const logoutTask = yield fork(forceLogout, time);
  yield take(API_AUTH_REFRESH_SUCCESS);
  yield cancel(logoutTask);
  yield call(loginFlow);
}

export function getTokenFromState(state) {
  let token = '';
  if (state !== undefined) {
    token = state.auth.token;
  }
  return token;
}

export function calculateTimeToDelay(token) {
  let iat = createDateFromSeconds(token.iat);
  let exp = createDateFromSeconds(token.exp);
  return exp - iat;
}

export function createDateFromSeconds(value) {
  return new Date(value * 1000);
}

export function* forceLogout(time) {
  yield delay(time);
  yield put(ApiActions.auth.logout());
}
